import {Routes} from '@angular/router';
import {HomeComponent} from './pages/home/home.component';
import {AuthGuard} from './guards/auth.guard';
import {suspendedTenantGuard} from './guards/suspended-tenant.guard';
import {OnboardingComponent} from "./modules/home/onboarding/onboarding.component";
import {MainMenuPath} from "./models/home/navigation.model";

export const routes: Routes = [
	{
		path: 'login',
		loadChildren: () => import('./pages/signin/signin.routes').then(m => m.signinRoutes)
	},
	{
		path: '',
		canActivate: [AuthGuard],
		canActivateChild: [suspendedTenantGuard],
		component: HomeComponent,
		loadChildren: () => import('./pages/home/home.routes').then(m => m.homeRoutes)
	},
	{
		path: 'new-tenant',
		canActivate: [AuthGuard],
		component: OnboardingComponent
	},
	{
		// OAuth consent page for MCP clients; the engine's /oauth/authorize redirects here
		path: 'mcp/consent',
		canActivate: [AuthGuard],
		loadComponent: () => import('./modules/mcp/consent/mcp-consent.component').then(m => m.McpConsentComponent)
	},
	{
		// Workspace integrations: every provider redirects here (the redirect URI registered on the provider side,
		// engine docs/integrations/connect-api.md). Public: an approval link's administrator has no Kabeen session, and
		// the page itself refuses a redirect with neither this tab's approval flow nor a session.
		path: 'integrations/callback',
		loadComponent: () => import('./modules/integrations/integration-callback/integration-callback.component').then(m => m.IntegrationCallbackComponent)
	},
	{
		// An approval link, opened by an administrator of the provider without a Kabeen account. Public.
		path: 'integrations/approve',
		loadComponent: () => import('./modules/integrations/integration-approval/integration-approval.component').then(m => m.IntegrationApprovalComponent)
	},
	{
		// Unknown URL: send to the home page — AuthGuard bounces anonymous users to the login.
		path: '**',
		redirectTo: MainMenuPath.HOME
	}
];
